// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gy9Fx","content":"styles_content__3ow_x","row":"styles_row__3OWcI","footer":"styles_footer__26etN","phraseLength":"styles_phraseLength__hWTzr"};